/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs */

const en_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant wants to send an invoice reminder.`)
};

const de_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Assistent möchte eine Zahlungserinnerung senden.`)
};

const es_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El asistente quiere enviar un recordatorio de factura.`)
};

const fr_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'assistant souhaite envoyer un rappel de facture.`)
};

const nl_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De assistent wil een factuurherinnering versturen.`)
};

const it_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'assistente vuole inviare un promemoria di fattura.`)
};

const pt_br2_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O assistente quer enviar um lembrete de fatura.`)
};

const pl_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asystent chce wysłać przypomnienie o fakturze.`)
};

/** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs) => LocalizedString} */
const hu_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = en_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders;

/** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs) => LocalizedString} */
const ro_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = en_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders;

/**
* | output |
* | --- |
* | "The assistant wants to send an invoice reminder." |
*
* @param {Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_approval_ask_tool_call_send_invoice_reminders = /** @type {((inputs?: Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Approval_Ask_Tool_Call_Send_Invoice_RemindersInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders(inputs)
	if (locale === "de") return de_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders(inputs)
	if (locale === "es") return es_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders(inputs)
	if (locale === "fr") return fr_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders(inputs)
	if (locale === "nl") return nl_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders(inputs)
	if (locale === "it") return it_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders(inputs)
	if (locale === "pl") return pl_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders(inputs)
	if (locale === "hu") return hu_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders(inputs)
	return ro_admin_ai_chat_approval_ask_tool_call_send_invoice_reminders(inputs)
});
export { admin_ai_chat_approval_ask_tool_call_send_invoice_reminders as "admin.ai_chat.approval_ask_tool_call.send_invoice_reminders" }